import React from 'react'
import _cx from 'classnames/bind'
import { Text, Modal, PopupTooltip } from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import type { OnlineAuctionSegmentBid } from '@adc/sdk/types'
import { ZERO_DOLLARS } from 'common/components/bidBanner/constants'
import ModalAddress from 'common/components/bidBanner/modalAddress'
import { formatMoneyWithNumeral } from 'common/utils/formatters'
import { NO_BIDDING_HISTORY } from 'common/statics'
import { CombinedListingType } from 'common/context/listing'
import cls from './styles.scss'

const cx = _cx.bind(cls)

// TODO: formatMoneyWithNumeral and the file it's in should be changed to typescript but for now can cast it here
const bidInDollars = (bid: Partial<OnlineAuctionSegmentBid>) =>
  formatMoneyWithNumeral(bid.bid_amount, ZERO_DOLLARS) as string

const COUNTER_BID_TOOLTIP_LABEL = 'Seller Counterbid'
const COUNTER_BID_TOOLTIP_CONTENT_1 =
  'Counterbids are common at online and in-person auctions.'
const COUNTER_BID_TOOLTIP_CONTENT_2 =
  'Auction.com may bid on behalf of the Seller to help move the price closer to, but not higher than, Reserve.'
const CounterBidTooltip = () => {
  return (
    <PopupTooltip
      position='top center'
      wide='very'
      trigger={
        <Text
          as='span'
          className={cx('tooltip-label')}
          color='info'
          data-elm-id='counter_bid_tooltip_label'
          size='small'
        >
          <span className='u-mr-1'>{COUNTER_BID_TOOLTIP_LABEL}</span>
        </Text>
      }
      content={
        /* When changing the content, make sure to adjust the modal min-height. */
        <Text
          size='tiny'
          color='white'
          data-elm-id='counter_bid_tooltip_content'
        >
          <p>{COUNTER_BID_TOOLTIP_CONTENT_1}</p>
          <p>{COUNTER_BID_TOOLTIP_CONTENT_2}</p>
        </Text>
      }
      horizontalOffset={0}
      verticalOffset={0}
      offset={0}
    />
  )
}

interface BiddingHistoryModalProps {
  biddingHistory?: Partial<OnlineAuctionSegmentBid>[]
  listing: CombinedListingType
  onClose?: () => void
  open?: boolean
}

export const BiddingHistoryModal = ({
  biddingHistory = [],
  listing,
  onClose,
  open,
}: BiddingHistoryModalProps) => {
  return (
    <Modal
      elmId='bidding_history_modal'
      mobileTitleSkin='light'
      size='tiny'
      title='Bid History'
      style={{ minHeight: 350 }}
      open={open}
      onClose={onClose}
    >
      <Modal.Content>
        <ModalAddress addressTuple={listing.formatted_address} />

        {!biddingHistory.length && (
          <Text color='gray'>{NO_BIDDING_HISTORY}</Text>
        )}

        <div className={cx('body-1')}>
          {biddingHistory.map((bid, i) => {
            const number = biddingHistory.length - i
            return (
              <div
                key={i}
                className={cx('bid', 'u-pb-1', 'u-pt-1')}
                data-elm-id={`bid_history_bid_${number}`}
              >
                <Text color='gray' className={cx('u-ml-2', 'u-mr-4')}>
                  {number}.
                </Text>
                <div>
                  <Text
                    as='span'
                    className='u-mr-1'
                    color='gray'
                    data-elm-id='bid_amount'
                  >
                    {bidInDollars(bid)}
                  </Text>
                  {bid.type ===
                  graph.enums.OnlineAuctionSegmentBidType.Seller ? (
                    <CounterBidTooltip />
                  ) : (
                    bid.belongs_to_current_user && (
                      <Text
                        as='span'
                        className={cx('current-user-bid')}
                        color='gray'
                        data-elm-id='user_bid'
                        weight='heavy'
                      >
                        (you)
                      </Text>
                    )
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </Modal.Content>
    </Modal>
  )
}
